import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

// Layouts
import Layout1 from '@/layout/Layout1'
import { Yetki } from '@/utils/enums'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/giris',
      name: 'OturumAc',
      component: () => import('@/views/auth/login')
    },
    {
      path: '/sifremi-unuttum',
      name: 'Sifremiunuttum',
      component: () => import('@/views/auth/sifremiUnuttumV2')
    },
    {
      path: '/sifre-sifirla',
      name: 'SifreSifirla',
      component: () => import('@/views/auth/sifreSifirla')
    },
    {
      path: '/giris-yap',
      name: 'EskiGirisYap',
      component: () => import('@/views/yonlendirme')
    },
    {
      path: '/kayit-ol',
      name: 'EskiKayitOl',
      component: () => import('@/views/yonlendirme')
    },
    {
      path: '/tanitim',
      name: 'EskiTanitim',
      component: () => import('@/views/yonlendirme')
    }, {
      path: '/hesabim',
      name: 'EskiHesabim',
      component: () => import('@/views/yonlendirme')
    },
    {
      path: '/',
      redirect: '/anasayfa',
      component: Layout1,
      children: [{
        path: 'anasayfa',
        component: () => import('@/views/home'),
        name: 'AnaSayfa'
      }, {
        path: 'kisi/liste',
        name: 'KisiListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/kisi')
      }, {
        path: 'ogrenci/liste',
        name: 'OgrenciListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/ogrenci')
      }, {
        path: 'sinif/liste',
        name: 'SinifListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinif')
      }, {
        path: 'sinif/arsiv',
        name: 'SinifArsivListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinif')
      }, {
        path: 'sinif/ogrenci/:id',
        name: 'SinifOgrenciListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinifOgrenci')
      }, {
        path: 'sinif/yoklama/:id',
        name: 'YoklamaListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/yoklama')
      }, {
        path: 'sinif/ders/:id',
        name: 'SinifDersListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinifDers')
      }, {
        path: 'sinif/otomatik/:id',
        name: 'OtomatikDersListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/otomatikders')
      }, {
        path: 'baslayacak-devam-edenler',
        name: 'BaslayacakDevamEdenler',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/baslayacakDevamEdenler')
      }, {
        path: 'rapor',
        name: 'Rapor',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/rapor')
      }, {
        path: 'dosyalar',
        name: 'Dosyalar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/dosya')
      }, {
        path: 'seminer/:id?',
        name: 'seminer',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA, Yetki.TALEBE]
        }],
        component: () => import('@/views/seminer')
      }, {
        path: 'seminerler',
        name: 'seminerler',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA, Yetki.TALEBE]
        }],
        component: () => import('@/views/seminerler')
      }, {
        path: 'yuzyuze-egitim-yerler',
        name: 'YuzyuzeEgitimYerler',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/yuzyuzeEgitimYerler')
      }, {
        path: 'seanslar',
        name: 'Seanslar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/seans')
      }, {
        path: 'okullar',
        name: 'Okullar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/okul')
      }, {
        path: 'sertifika',
        name: 'sertifika',
        meta: [{
          Roles: [Yetki.TALEBE]
        }],
        component: () => import('@/views/sertifika')
      }, {
        path: 'profilim',
        name: 'profilim',
        meta: [{
          Roles: [Yetki.TALEBE]
        }],
        component: () => import('@/views/kayit-yeni/profilim')
      }, {
        path: 'sertifika-olusturucu',
        name: 'sertifika-olusturucu',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sertifikaolusturucu')
      }, {
        path: 'hocasi-olmayan-siniflar',
        name: 'hocasi-olmayan-siniflar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/hocasi-olmayan-siniflar.vue')
      }]
    }, {
      path: '*',
      component: NotFound
    }]
})

export default router
